function AmazonPayoutCtrl(toaster, $scope, $state, $stateParams, AppSettings, AmazonPayoutService, CommonService, $rootScope) {
  'ngInject';

  $rootScope.$on('UpdateAmazonPayoutInvoiceFromNotification', function (event, invoice) {
    vm.UpdateAmazonPayoutInvoiceFromNotification(invoice);
  });

  const vm = this;
  vm.loading = false;
  vm.dataLoading = false;
  vm.btndisabled = false;
  vm.retryActive = false;
  vm.fileForm = {};
  vm.invoices = [];
  vm.mappings = [];
  vm.payoutForm = {};
  vm.searchForm = {};
  vm.responseReceived = false;
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.searchForm.todate = !$stateParams.todate ? '' : $stateParams.todate;
  vm.searchForm.fromdate = !$stateParams.fromdate ? '' : $stateParams.fromdate;
  vm.searchForm.invoiceId = !$stateParams.invoiceId ? '' : $stateParams.invoiceId;
  vm.searchForm.marketplace = !$stateParams.marketplace ? '' : $stateParams.marketplace;
  vm.sortBy = !$stateParams.sortBy ? 'date_from' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.postToXero = false;
  vm.dateRegex = AppSettings.dateRegex;
  vm.yearMonthRegex = AppSettings.yearMonthRegex;
  vm.isPendingJobs = false;
  vm.tryNowDate = '';
  vm.tryLoading = false;
  vm.groupedInvoices = [];
  vm.subInvoices = {};
  vm.marketplaceList = ['All'];

  vm.init = function () {
    vm.dataLoading = true;
    if ($stateParams.orgId) {
      vm.loadMarketplaceList();
      vm.loadInvoices();
    }
  };

  vm.loadInvoices = function () {
    vm.url = `/organizations/${$stateParams.orgId}/amazon_payout_invoices.json?page=${vm.pageNumber}&size=${vm.size}&by_invoice_number=${vm.searchForm.invoiceId}&by_date_from=${vm.searchForm.fromdate}&by_date_to=${vm.searchForm.todate}&marketplace=${vm.searchForm.marketplace}&sort=${vm.sortBy}`;
    AmazonPayoutService.getInvoices($stateParams.orgId, vm.url, vm.pageNumber, vm.size, function (response) {
      vm.dataLoading = false;
      if (response.status == 200) {
        vm.response = response.data;
        vm.currentPage = !vm.response.pagination ? 1 : vm.response.pagination.current_page;
        vm.totalPages = !vm.response.pagination ? 1 : vm.response.pagination.total_page;
        vm.invoices = response.data.amazon_payout_invoices;
        vm.groupedInvoices = response.data.grouped_amazon_payout_invoices;
        vm.setSubInvoices();
      }
    });

    AmazonPayoutService.getMappings($stateParams.orgId, function (response) {
      if (response.status == 200) {
        vm.mappings = response.data.mappings;
      }
    });
  };

  vm.setSubInvoices = function () {
    if (vm.invoices) {
      vm.settlementIds = vm.groupedInvoices.map(x => x.settlement_id);
      if (vm.settlementIds) {
        vm.settlementIds.forEach(element => {
          vm.subInvoices[element] = vm.invoices.filter(function (i) {
            return (i.settlement_id == element);
          });
        });
      }
    }
  };

  vm.loadMarketplaceList = function () {
    AmazonPayoutService.allMarketplace($stateParams.orgId, function (response) {
      if (response.status == 200) {
        vm.marketplaceList = vm.marketplaceList.concat(response.data.marketplace_list);
      }
    });
  };

  vm.getGroupedStatus = function (invoice) {
    let statusArray = [];
    if (invoice.multi_invoice_count > 1) {
      statusArray = vm.subInvoices[invoice.settlement_id].map(function (s) {
        return s.status;
      });
    } else {
      statusArray = invoice.status;
    }
    if (statusArray.includes('new')) {
      return 'new';
    } else if (statusArray.includes('account')) {
      return 'account';
    } else if (statusArray.includes('ready')) {
      return 'ready';
    } else if (statusArray.includes('running')) {
      return 'running';
    } else if (statusArray.includes('done')) {
      return 'done';
    }
    return '';
  };

  vm.viewDetail = function (invoiceId) {
    $state.go('user.organization.dashboard.amazonPayout.details', {
      orgId: $stateParams.orgId,
      invoiceId: invoiceId
    }, {
      inherit: false
    });
  };

  vm.getInvoice = function () {
    if ($stateParams.invoiceId) {
      AmazonPayoutService.getInvoice($stateParams.orgId, $stateParams.invoiceId, function (response) {
        vm.invoice = response.data;
      });
    } else {
      $state.go('user.organization.dashboard.amazonPayout.invoices', {
        inherit: false
      });
    }
  };

  vm.UpdateAmazonPayoutInvoiceFromNotification = function (invoice) {
    if (Array.isArray(invoice)) {
      vm.init();
    }
  };

  vm.search = function () {
    if (vm.searchForm.marketplace == 'All') {
      vm.searchForm.marketplace = '';
    }
    vm.routeChange('user.organization.dashboard.amazonPayout.invoices');

    vm.loadInvoices();
  };

  vm.sortFlag = function (param) {
    var currentSort = $stateParams.sortBy;
    if (currentSort && currentSort.includes(param)) {
      if (!currentSort.includes('-')) {
        return false;
      }
    }
    return true;
  };

  vm.sort = function (param) {
    var currentSort = $stateParams.sortBy;
    if (currentSort && currentSort.includes(param)) {
      if (!currentSort.includes('-')) {
        param = '-' + param;
      }
    }
    $state.go('user.organization.dashboard.amazonPayout.invoices', {
      sortBy: param
    });
  };

  vm.paginate = function (param) {
    vm.url = vm.response.links[param];
    if (vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      vm.routeChange('user.organization.dashboard.amazonPayout.invoices');
      vm.loadInvoices();
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.response.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
    vm.routeChange('user.organization.dashboard.amazonPayout.invoices');
    vm.loadInvoices();
  };

  vm.routeChange = function (route) {
    $state.go(route, {
      pageNumber: vm.pageNumber,
      size: vm.size,
      invoiceId: vm.searchForm.invoiceId,
      fromdate: vm.searchForm.fromdate,
      todate: vm.searchForm.todate,
      marketplace: vm.searchForm.marketplace
    }, { //does not change the state
      notify: false,
      reload: false,
      location: 'replace',
      inherit: true
    });
  };

  vm.onPikadaySelect = function (pikaday) {
    vm.amazonfileForm.date = pikaday.toString('YYYY-MM');
  };

  vm.onPikadayOpen = function (pikaday) {
    vm.payoutForm.startDate.setMaxDate(new Date());
    vm.payoutForm.endDate.setMaxDate(new Date());
  };

  vm.onPickadayTo = function (pikaday) {
    vm.searchForm.todate = pikaday.toString();
    vm.fromDatePicker.setMaxDate(new Date(vm.searchForm.todate));
  };

  vm.onPickadayFrom = function (pikaday) {
    vm.searchForm.fromdate = pikaday.toString();
    vm.toDatePicker.setMinDate(new Date(vm.searchForm.fromdate));
  };

  vm.onPickadayStart = function (pikaday) {
    vm.payoutForm.startDate = pikaday.toString('YYYY-MM');
  };

  vm.onPickadayEnd = function (pikaday) {
    vm.payoutForm.endDate = pikaday.toString('YYYY-MM');
  };

  vm.viewInvoice = function (invoice) {
    AmazonPayoutService.getInvoice($stateParams.orgId, invoice.id, function (response) {
      vm.journal = response.data;
      if (response.status == 200) {
        $state.go('user.organization.dashboard.amazonPayout.invoices', {
          invoiceId: invoice.id
        }, {
          inherit: false
        });
      }
    });
  };

  vm.uploadFile = function (payoutForm) {
    vm.loading = true;
    vm.btndisabled = true;
    AmazonPayoutService.saveFile(vm.payoutForm, $stateParams.orgId, function (response) {
      vm.loading = false;
      vm.btndisabled = false;
      vm.responseReceived = true;
      vm.payoutForm = {};
      payoutForm.$setPristine();
      payoutForm.$setUntouched();
      if (response.status >= 200 & response.status < 300) {
        toaster.pop('info', 'File uploaded successfully');
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.getStatusClass = function (invoice) {
    let label = '';
    if (invoice.multi_invoice_count > 1) {
      status = vm.getGroupedStatus(invoice);
    } else {
      status = invoice.status;
    }
    switch (status) {
      case 'account':
        label = 'label-danger';
        break;
      case 'new':
        label = 'label-warning';
        break;
      case 'running':
        label = 'label-primary';
        break;
      case 'done':
        label = 'label-success';
        break;
      case 'ready':
        label = 'label-primary';
        break;
      default:
    }
    return label;
  };

  vm.retryInvoiceProcess = function (invoiceId, forcePost) {
    vm.retryActive = invoiceId;
    vm.postToXero = forcePost;
    AmazonPayoutService.retryInvoiceProcess($stateParams.orgId, invoiceId, forcePost, function (response) {
      vm.retryActive = null;
      vm.postToXero = false;
      if (response.status >= 200 & response.status < 300) {
        toaster.pop('info', response.data.message);
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.onTryNowDateSelect = function (pikaday) {
    vm.tryNowDate = pikaday.toString('YYYY-MM-DD');
  };

  vm.tryNow = function () {
    vm.tryLoading = true;
    AmazonPayoutService.tryNow($stateParams.orgId, vm.tryNowDate, function (response) {
      vm.tryLoading = false;
      if (response.status >= 200 && response.status < 300) {
        toaster.pop('info', response.data.data);
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.onPikadayOpenTryNow = function (pikaday) {
    pikaday.setMaxDate(new Date());
  };

  vm.tooltipStatus = function (status) {
    let tooltipTitle = '';
    switch(status){
      case 'account':
        tooltipTitle = 'Mapping or mapping account information is missing';
        break;
      case 'ready':
        tooltipTitle = 'Invoice is ready to be posted to Xero';
        break;
      case 'running':
        tooltipTitle = 'Invoice is being processed';
        break;
      case 'done':
        tooltipTitle = 'Invoice is already processed';
        break;
      default:
    }
    return tooltipTitle;
  };
}

export default {
  name: 'AmazonPayoutCtrl',
  fn: AmazonPayoutCtrl
};
